import socketIOClient from "socket.io-client";

import {config} from './../config';

class SocketApi{
    socket;
    initialize(){       

        //console.log('socket initialize');

        this.socket = socketIOClient(config.baseURL);

        this.socket.on('connect',()=>{
            //console.log('Client side connect');                        

            //this.getHint();
        });

        
    }

    

    getHint(getHintDTO){

        return new Promise((resolve,reject)=>{
            
            this.socket.once('hint-result',(hintResult)=>{
                resolve(hintResult);
            });
    
            this.socket.emit('get-hint',getHintDTO);

        });

        
    }
}


export const socketApi = new SocketApi();